import CourseCard from "@components/CourseCard";
import { IconWithTooltip } from "@components/IconWithTooltip";
import {
  ArrowRightCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/16/solid";
import { useIsUserRole } from "@hooks/auth";
import { CourseUserDetailsDTO } from "@onetutor/shared/dto";
import { buildQueryString } from "@utils/api.util";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface HomepageCourseCardProps {
  course: CourseUserDetailsDTO;
}

function HomepageCourseCard(props: HomepageCourseCardProps) {
  const navigate = useNavigate();
  const { t } = useTranslation("coursePage");
  const { t: tCommon } = useTranslation("commons");
  const isAdmin = useIsUserRole("admin");

  const openCourse = () => {
    navigate(`course/${props.course.id}`);
  };

  const editCourse = () => {
    const path = buildQueryString(`course/${props.course.id}/manage`, {
      edit: true,
    });
    navigate(path);
  };

  const renderButtons = () => {
    if (props.course.isManaging || isAdmin) {
      return (
        <IconWithTooltip
          icon={<PencilSquareIcon className="h-7 w-7" />}
          tooltip={tCommon("edit")}
          handler={editCourse}
          className="btn btn-ghost btn-circle"
        />
      );
    } else {
      return (
        <IconWithTooltip
          icon={<ArrowRightCircleIcon className="h-7 w-7" />}
          tooltip={t("goToCourse")}
          handler={openCourse}
          className="btn btn-ghost btn-circle"
        />
      );
    }
  };

  return (
    <CourseCard
      course={props.course}
      onClick={openCourse}
      showUniversityBadge={false}
    >
      {renderButtons()}
    </CourseCard>
  );
}

export default HomepageCourseCard;
